import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  table_container: {
    marginTop: 30,
  },
}));

export default useStyles;
